import { render, staticRenderFns } from "./HomeFaultTrend.vue?vue&type=template&id=2a60b022&scoped=true&"
import script from "./HomeFaultTrend.vue?vue&type=script&lang=js&"
export * from "./HomeFaultTrend.vue?vue&type=script&lang=js&"
import style0 from "./HomeFaultTrend.vue?vue&type=style&index=0&id=2a60b022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a60b022",
  null
  
)

export default component.exports